/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Seller_Notice_RegistrationInputs */

const en_seller_notice_registration = /** @type {(inputs: Seller_Notice_RegistrationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reg. no. ${i?.number}`)
};

const pl_seller_notice_registration = /** @type {(inputs: Seller_Notice_RegistrationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`nr rej. ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Reg. no. {number}" |
*
* @param {Seller_Notice_RegistrationInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_registration = /** @type {((inputs: Seller_Notice_RegistrationInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_RegistrationInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_registration(inputs)
	return en_seller_notice_registration(inputs)
});